import {IChatEnvelope} from "../../interfaces/chat-interface";
import {jsDateToEpoch} from "../../common";
import * as _ from "lodash";

declare let TweenLite: any;

export class ChatHelper {

    debounceTyping;

    constructor() {
        // this.debounceTyping = _.debounce(() => {
        //     console.log('Function debounced after 1000ms!');
        // }, 1000);
        // this.debounceTyping();
    }


    public getPayload(i_payload): IChatEnvelope {
        const payload = _.cloneDeep(i_payload);
        if (payload && !payload?.time) payload.time = jsDateToEpoch(new Date());
        return payload;
    }

    public fixLinks(userInput: string): string {
        if (userInput.indexOf('http') > -1) {
            const pattern = /((http|https|ftp):\/\/[\w?=&.\/-;#~%-]+(?![\w\s?&.\/;#~%"=-]*>))/ig;
            userInput = userInput.replace(pattern, `<a class="chatConversation" href='$1' target='_blank'>$1</a>`);
        }
        return userInput;
    }

    // public onUserTyping(socket: Socket) {
    //     this.debounceTyping();
    // }

    public scrollToBottom(i_conv = []) {
        const speed = i_conv.length > 10 ? 1 : 5;
        setTimeout(() => {
            // document.getElementById("container1").scrollTop = document.getElementById("container2").offsetHeight;
            const el = document.getElementById("container2");
            if (!el) return;
            const offset = el.offsetHeight;
            const c1: any = document.getElementById("container1");
            TweenLite.to(c1, speed, {scrollTo: {y: offset}});
        }, 10);
    }
}
